<div class="fs-2 with-close" mat-dialog-title>
    Édition
    <i class="fa fa-close" (click)="onNoClick()" aria-hidden="true"></i>
</div>
<div mat-dialog-content>
    <div class="card-text row">
        <div class="col-md-12">
            <mat-form-field class="lines-3">
                <mat-label>Description</mat-label>
                <textarea matInput rows="12" [(ngModel)]="favorite.description"></textarea>
            </mat-form-field>
        </div>
    </div>
</div>
<div mat-dialog-actions>
    <button type="button" (click)="onNoClick()"  class="btn btn-outline">
        Annuler
    </button>
    <button type="button" (click)="onYesClick()"  class="btn btn-primary">
        Valider
    </button>
</div>
